import { useState } from "react";
import { X, MessageSquare } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const UNITS = ["mm", "cm", "m", "m2", "m3"];

export default function MeasurementRow({ measurement, index, onChange, onRemove }) {
  const [showNotes, setShowNotes] = useState(Boolean(measurement.notes));
  const update = (field, value) => {
    onChange(index, { ...measurement, [field]: value });
  };

  return (
    <div className="space-y-1.5" data-testid={`measurement-row-${index}`}>
      <div className="grid grid-cols-12 gap-2 items-center">
      <div className="col-span-5">
        <Input
          placeholder="Label (e.g. Room width)"
          value={measurement.label}
          onChange={(e) => update("label", e.target.value)}
          className="h-9 rounded-sm border-slate-300 text-sm"
          data-testid={`measurement-label-${index}`}
        />
      </div>
      <div className="col-span-3">
        <Input
          placeholder="Value"
          value={measurement.value}
          onChange={(e) => update("value", e.target.value)}
          className="h-9 rounded-sm border-slate-300 text-sm font-mono text-right"
          data-testid={`measurement-value-${index}`}
        />
      </div>
      <div className="col-span-2">
        <Select value={measurement.unit} onValueChange={(v) => update("unit", v)}>
          <SelectTrigger className="h-9 rounded-sm border-slate-300 text-sm" data-testid={`measurement-unit-${index}`}>
            <SelectValue placeholder="Unit" />
          </SelectTrigger>
          <SelectContent>
            {UNITS.map(u => (
              <SelectItem key={u} value={u}>{u}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="col-span-1 flex justify-center">
        <Button
          variant="ghost"
          size="sm"
          className={`h-8 w-8 p-0 ${measurement.notes ? "text-orange-500" : "text-slate-400"} hover:text-orange-600`}
          onClick={() => setShowNotes(s => !s)}
          title={measurement.notes ? "Has notes from site visit" : "Add a note"}
          data-testid={`toggle-notes-${index}`}
        >
          <MessageSquare className="w-4 h-4" />
        </Button>
      </div>
      <div className="col-span-1 flex justify-center">
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0 text-slate-400 hover:text-red-500"
          onClick={() => onRemove(index)}
          data-testid={`remove-measurement-${index}`}
        >
          <X className="w-4 h-4" />
        </Button>
      </div>
      </div>
      {showNotes && (
        <Input
          placeholder="Note (context, e.g. 'main bedroom, before pitch deduction')"
          value={measurement.notes || ""}
          onChange={(e) => update("notes", e.target.value)}
          className="h-8 rounded-sm border-slate-300 text-xs italic"
          style={{ background: "#FFF7ED" }}
          data-testid={`measurement-notes-${index}`}
        />
      )}
    </div>
  );
}
